import { FC, lazy, Suspense } from 'react';
import { PdpSharedDetail, PdpSharedDetailProps } from '../shared/PdpSharedDetail/PdpSharedDetail';

type Props = PdpSharedDetailProps & {
    afterDisplay: boolean;
    showOnTop?: boolean;
};

export const PdpSharedDetailLabReport: FC<Props> = ({ afterDisplay, showOnTop, ...props }) => {
    const LabReportTip = lazy(
        () =>
            import(
                /* webpackChunkName: "PdpSharedDetailLabReportTip" */ '../shared/PdpSharedDetail/PdpSharedDetailLabReportTipLazy'
            )
    );

    return (
        <>
            <PdpSharedDetail {...props} />
            {afterDisplay && (
                <Suspense fallback="">
                    <LabReportTip showOnTop={showOnTop} />
                </Suspense>
            )}
        </>
    );
};
